export default "__VITE_ASSET__CtxE4IUL__"